import React from 'react';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import TextInput from '../inputs/textInput';
import TrackingSourceSelect from '../dropdownSelects/trackingSourceSelect';
import { useUpdateCampaign } from '../../apiHooks/mutations/adManagementMutations/campaignsMutations';
import { CustomButton } from '../buttons/customButton';

interface CampaignFormProps {
    initialValues?: any;
    onSubmit: () => void;
    close: () => void;
    setSelectedCampaignCode : (_campaignCode : string) => void;
}

const CampaignForm: React.FC<CampaignFormProps> = (props) => {
  const { t } = useTranslation();
  const { mutateAsync: updateCampaign } = useUpdateCampaign();
  const formik = useFormik({
    initialValues: props.initialValues || {
      id: 0,
      name: '',
      campaignCode: '',
      trackingSourceId: '',
    },
    onSubmit: async (values) => {
      await updateCampaign(values).then(
        (response) => props.setSelectedCampaignCode(response?.data?.data?.id),
      );
      props.onSubmit();
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="flex w-full flex-col items-center">
      <div className="flex w-full flex-col">
        <div className="mb-4 mt-2 w-full">
          <TextInput
            id="name"
            myKey="name"
            className="w-full"
            size="small"
            name="name"
            value={formik.values.name}
            placeholder={t('name')}
            onChange={(e) => formik.handleChange(e)}
            label={t('name')}
          />
        </div>
        <input type="hidden" name="campaignCode" value={formik.values.adGroupCode} />
        <div className="mb-4 w-full">
          <TextInput
            myKey="Conversion Value"
            className="w-full"
            size="small"
            name="Conversion Value"
            value={formik.values.conversionValue}
            placeholder={t('Conversion Value')}
            onChange={formik.handleChange}
            label={t('Conversion Value')}
          />
        </div>
        <TrackingSourceSelect
          size="small"
          data={formik.values?.trackingSource}
          formik={formik}
          label="Select Tracking Source"
          placeholder="Select Tracking Source"
        />
      </div>
      <div className="flex w-full items-center justify-end gap-2 pb-2 pt-8">
        <CustomButton
          variant="noOutline"
          type="button"
          onClick={() => props.close()}
          className="rounded-lg px-4 py-2.5 text-primary"
        >
          {t('cancel')}
        </CustomButton>
        <CustomButton type="submit" className="rounded-lg bg-primary px-4 py-2.5 text-white">
          {t('create')}
        </CustomButton>
      </div>
    </form>
  );
};

export default CampaignForm;
